export { GTMEventKey, CustomEventName, GTMConstants, GTMAnalytics, sendGTM } from "./lib/fe-common-gtm";